var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.874 15.248l.256.256 9.844-9.844-1.413-1.413-8.434 8.436L1.44 3.996.025 5.41l9.844 9.843.004-.005z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }